import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { Station } from '../models/station';
import 'rxjs/add/operator/delay';
@Injectable()
export class StationUsageService {

  constructor() { }

  getStationUsageStats() {
    // TODO call ws

    return of(JSON.parse('{"mostUsed": "Jean-Jaurès", "leastUsed": "Esquirol", "mostFull" : "Gare Matabiau", "leastFull": "Jeanne d\'Arc"}')).delay(400);

  }

}



// WEBPACK FOOTER //
// ./src/app/statistics/station-usage.service.ts